import { graphql, useStaticQuery } from 'gatsby';
import React from 'react'

import FooterMenu from './FooterMenu'

function Footer(props)
{
  const data = useStaticQuery(graphql`
    query FooterQuery{
      allDatoCmsMenuWidget(filter: {name: {ne: "Header menu"}}, sort: {order: ASC, fields: name}) {
        nodes {
          id
          title
          model {
            apiKey
          }
          menu {
            ... on DatoCmsBlockMenuItem {
              id
              model {
                apiKey
              }
              title
              url {
                slug
                name
              }
            }
            ... on DatoCmsBlockContent {
              id
              model{
                apiKey
              }
              name
              content {
                ... on DatoCmsContent {
                  id
                  model {
                    apiKey
                  }
                  text {
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  return (
    <footer className="p-8 bg-blue w-screen">
      <div className="max-w-8xl grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-24 mx-auto ">
        {data.allDatoCmsMenuWidget.nodes.map(node =>
        (
          < FooterMenu key={node.title} title={node.title} menu={node.menu} />
        ))}
      </div>
    </footer>
  );
}

export default Footer;

